import PropTypes from 'prop-types';

const propType = {
  _id: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  highlight: PropTypes.bool,
  viewCount: PropTypes.number,
};

export default { propType };
